import { render, staticRenderFns } from "./mb-solution.vue?vue&type=template&id=78762dae&"
import script from "./mb-solution.vue?vue&type=script&lang=js&"
export * from "./mb-solution.vue?vue&type=script&lang=js&"
import style0 from "./mb-solution.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports